import styled from 'styled-components';
import Button from 'components/Button';
import { BlockSize } from 'libs/rendering/gltf/config';

export const DfmViewportWrapper = styled.section`
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  position: relative;
  top: 0;
  height: 100%;
`;

const titleHeight = 20;

export const RadioButtonStyled = styled(Button)`
  display: flex;
  justify-content: ${props => (props.atRight ? 'flex-end' : 'center')};
  align-items: center;
  border-radius: ${props => props.round && BlockSize.desktopWidth};
  width: ${titleHeight}px;
  height: ${titleHeight}px;
  margin: 0 ${props => props.theme.spacing.xsmall};
  color: ${props =>
    props.selected || props.waiting
      ? props.theme.color.wfWhite
      : props.theme.color.wfBlack};
  background-color: ${props =>
    props.selected
      ? props.theme.color.wfBlue
      : props.waiting
      ? props.theme.color.wfOrange
      : props.theme.color.wfWhite};
  &:hover {
    color: black;
    text-decoration: none;
    background-color: ${props => !props.working && props.theme.color.wfBlue300};
    cursor: ${props => (!props.working ? 'pointer' : 'default')};
  }
`;
